module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.json)
    }
  }, [_vm._v("\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25c82147!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Json.vue
// module id = 488
// module chunks = 2